import React from 'react'

// Single checkbox row used inside any multi-select panel.
// `locked` renders as checked + disabled (cannot toggle).
//
// DEV-2980: the storefront's facet row (.fb-menu-row) with its native
// checkbox; `parent` is the bold group row, `child` the indented one.

export default function CheckboxOption({ label, count, checked, locked, onToggle, parent, child }) {
  const cls = ['fb-menu-row', parent ? 'fb-menu-parent' : '', child ? 'fb-menu-child' : '', locked ? 'is-locked' : ''].filter(Boolean).join(' ')
  return (
    <label className={cls}>
      <input
        type="checkbox"
        checked={!!(checked || locked)}
        disabled={locked}
        onChange={locked ? undefined : onToggle}
      />
      <span className="fb-menu-label">{label}</span>
      {typeof count === 'number' && <span className="fb-menu-count">{count}</span>}
    </label>
  )
}
